const CHAT_TYPES = {
    VISITOR: undefined,
    THREAD: "thread",
    DEPARTMENT: "department",
    GROUP_THREAD: "groupThread",
    TEAM: "team",
};

module.exports = CHAT_TYPES;
